import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Initialize Sentry
Sentry.init({
  dsn: "https://198c0aeada45a23777d3dfc3838aa344@o4511293586604032.ingest.us.sentry.io/4511293589356544",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
  // Session Replay
  replaysSessionSampleRate: 0.1, // 10% of sessions
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
  // Environment and release tracking
  environment: environment.version.production ? 'production' : 'development',
  release: environment.version.appVersion,
});

if (environment.version.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.log(err);
    Sentry.captureException(err);
  });
